module.exports = __webpack_public_path__ + "img/app-store-badge.bbb6bf29.png";